import React, {
  createContext,
  ReactNode,
  useContext,
  useMemo,
  useReducer,
} from 'react';
import { VideosState, GlobalAction } from '.';
import { videosReducer } from './videosReducer';

type Props = {
  children: ReactNode;
};

type ContextProps = {
  state: VideosState;
  dispatch: React.Dispatch<GlobalAction>;
};

const VideosContext = createContext({} as ContextProps);

const initialState: VideosState = {
  videos: {},
  mergeModal: {
    library: {
      Primary: { videos: [] },
    },
    currentFolder: undefined,
  },
  wtvModal: {
    library: {
      Primary: { videos: [] },
    },
  },
};

export const VideosContextProvider = ({ children }: Props) => {
  const [state, dispatch] = useReducer(videosReducer, initialState);
  const value = useMemo(() => ({ state, dispatch }), [state]);
  return (
    <VideosContext.Provider value={value}>{children}</VideosContext.Provider>
  );
};

export const useVideosContext = () => useContext(VideosContext);
